// import React, { useState } from "react";
// import Navbar from "../../Components/Navbar";
// import Footer from "../../Components/Footer/Footer";
// import "./faqPageStyle.css";
// import { FaChevronDown, FaUserAlt, FaTools } from "react-icons/fa";

// const FaqPage = () => {
//   const [openIndex, setOpenIndex] = useState(null);
//   const [openIndexServitor, setOpenIndexServitor] = useState(null);

//   const toggleQuestion = (index, type = "user") => {
//     if (type === "user") {
//       setOpenIndex(openIndex === index ? null : index);
//     } else {
//       setOpenIndexServitor(openIndexServitor === index ? null : index);
//     }
//   };

//   // const userFaqs = [
//   //   {
//   //     q: "How can I register?",
//   //     a: "You can register easily from the HelpNao website or mobile app by selecting 'Sign Up' and providing your name, phone number, and password. After verification, your account will be ready to use.",
//   //   },
//   //   {
//   //     q: "How can I place an order?",
//   //     a: "Choose the service you need (like Electrician, Plumber, or Tutor), fill in the required details, preferred date & time, and submit. Our verified servitors will confirm your booking shortly.",
//   //   },
//   //   {
//   //     q: "How can I track my order?",
//   //     a: "After placing an order, go to 'My Orders' in your profile. You’ll see the real-time status of your request — from pending, confirmed, to completed.",
//   //   },
//   //   {
//   //     q: "Can I rebook the same servitor?",
//   //     a: "Yes! Once you complete a service, you can easily rebook the same servitor from your order history with just one click.",
//   //   },
//   //   {
//   //     q: "How can I earn rewards and get discounts?",
//   //     a: "Earn rewards by completing services, referring friends, or using promo codes. Your rewards balance can be applied automatically during checkout for discounts.",
//   //   },
//   // ];

//     const userFaqs = [
//     {
//       q: "How can I register?",
//       a: "You can register from the HelpNao website or mobile app by tapping “Sign Up” and entering your name, mobile number, and a password/OTP. After verification, your account will be ready to use.",
//     },
//     {
//       q: "How do I place a service order?",
//       a: "Select the service you need (for example Electrician, Plumber, Gas Stove, AC Service), fill in your address, preferred date and time, and submit the request. Nearby verified servitors will receive your order and one of them will accept it.",
//     },
//     {
//       q: "Can I change or cancel a booking?",
//       a: "Yes. Before a servitor accepts the order, you can edit or cancel it from the “My Orders” section without any charge. After acceptance, cancellation options and any possible fee will be shown clearly in the app.",
//     },
//     {
//       q: "How do I know the servitor is verified and safe?",
//       a: "All servitors are verified with NID and background checks before being approved on HelpNao. For extra safety, when the servitor arrives you should match the 6-character verification code/PIN in the app with the code shown by the servitor before allowing work to start.",
//     },
//     {
//       q: "How do payments work?",
//       a: "You pay only after the service is completed. Payment is made directly to the servitor, usually in cash. If you want to use a digital method like bKash or Nagad, please discuss with the servitor first and use the number or method they are comfortable with. Never send advance payments or transfer money to any unknown personal number shared outside the HelpNao app or official communication.",
//     },
//     {
//       q: "What if there is a problem or damage during service?",
//       a: "If you face poor service, damage, or any unsafe behaviour, please report it immediately from the order details or contact HelpNao Support. We will review the issue, may hold the servitor’s payment, and take action based on our policies.",
//     },
//     {
//       q: "How do reward points work?",
//       a: "After each successfully completed order, you earn reward points. When your balance reaches 100 points or more, you can claim special coupons. Different point levels unlock different types of coupons and benefits. Points themselves are not cash but can be converted into discounts through coupons.",
//     },
//     {
//       q: "How do I use a coupon for discount?",
//       a: "When placing an order, you will see an option to apply a coupon on the order or payment screen. If you have a valid coupon, select or enter it there and your discount will be shown before you confirm the order. Each coupon has its own rules, and normally every coupon is valid for 30 days from the date it is issued.",
//     },

//     {
//       q: "Can I rebook the same servitor?",
//       a: "Yes. After a service is completed, you can go to your Order History and choose “Rebook” to place a new request with the same servitor, if they are available in your area and time slot.",
//     },
//   ];


//   // const servitorFaqs = [
//   //   {
//   //     q: "How can I register and login?",
//   //     a: "Go to 'Start Earning' on our website or app, click 'Join as Servitor', and complete your profile with NID, photo, and skills. Once verified, you can log in and start receiving jobs.",
//   //   },
//   //   {
//   //     q: "How can I earn money?",
//   //     a: "Accept and complete customer service requests. Payments are made directly from customers after service completion, minus a small commission.",
//   //   },
//   //   {
//   //     q: "Can I get orders based on my area?",
//   //     a: "Yes. You’ll receive nearby orders based on your selected working area during registration. You can also update your location anytime.",
//   //   },
//   //   {
//   //     q: "Can I track my orders?",
//   //     a: "Absolutely. The Servitor Dashboard shows all active, pending, and completed orders with real-time updates and customer details.",
//   //   },
//   //   {
//   //     q: "How many orders can I accept?",
//   //     a: "You can accept multiple orders depending on your availability and rating. Completing more verified orders helps you unlock higher earning opportunities.",
//   //   },
//   // ];


//     const servitorFaqs = [
//     {
//       q: "How can I register as a Servitor?",
//       a: "Tap “Start Earning” or “Join as Servitor” in the HelpNao app, then complete your profile with your mobile number, NID information, clear photo, and service skills (for example Electrician, Plumber, Gas Stove, AC). After our team verifies your information, your account will be activated.",
//     },
//     {
//       q: "Am I an employee of HelpNao?",
//       a: "No. As a Servitor you work as an independent contractor. HelpNao connects you with customers and manages the platform, but you are responsible for your own work quality, tools, behaviour, and tax/financial obligations.",
//     },
//     {
//       q: "How do I receive orders?",
//       a: "You will receive job requests based on your selected service category, working area, and availability. When you see a suitable order, you can review the details and then accept or decline it directly from the app.",
//     },
//     {
//       q: "How do I earn and withdraw money?",
//       a: "You earn money after you complete an order and the status is marked as finished in the app. After any checks or complaints are resolved, the earning appears in your in-app wallet (minus the platform fee shown in the app). From there you can request withdrawal to your available payout methods.",
//     },
//     {
//       q: "Is there any platform fee or commission?",
//       a: "Yes. HelpNao deducts a small platform or service fee from each completed job to cover technology, support and marketing costs. The exact rate will be shown in the app or official communication before you accept orders.",
//     },
//     {
//       q: "What happens if I cancel or miss orders?",
//       a: "You should only accept orders that you are able to complete. If you miss or cancel an order after accepting it, an automatic penalty may apply. Continuous cancellations or missed orders can lead to stronger action such as lower priority for new jobs, temporary suspension, or other steps under the Servitor Agreement. If you face a serious issue or emergency, contact the HelpNao Support Team as soon as possible. After reviewing your case, the team will decide what action to take according to the platform policy.",
//     },

//     {
//       q: "Why could my account be suspended or blocked?",
//       a: "Accounts may be suspended for serious complaints, proven misconduct, fraud, unsafe work, harassment, damage to customer property, repeated rule violations, or suspicious activity. HelpNao reviews each case carefully before taking action.",
//     },
//     // {
//     //   q: "Can I use customer phone numbers or photos for my own business?",
//     //   a: "No. You must not save, sell, or reuse customer phone numbers, addresses, photos, or documents for your personal marketing or any outside business. Customer data may only be used through the HelpNao platform for the specific service order.",
//     // },
//     {
//       q: "How do ratings affect my work?",
//       a: "After each job, customers can rate and review you. Higher ratings and good behaviour help you get more orders and special benefits. Consistently low ratings, repeated complaints, or poor performance may reduce your order volume or lead to account review.",
//     },
//   ];


//   return (
//     <>
//     <div className="faq-page">
//       <Navbar />
//       <section className="faq-hero">
//         <div className="faq-container">
//           <h1 className="faq-title">Frequently Asked Questions (FAQ)</h1>
//           <p className="faq-subtitle">
//             Find quick answers to your most common questions about using HelpNao as a User or Servitor.
//           </p>
//         </div>
//       </section>

//       <section className="faq-section">
//         <div className="faq-container">
//           {/* USER SECTION */}
//           <div className="faq-block">
//             <div className="faq-block-header">
//               <FaUserAlt className="faq-block-icon" />
//               <h2>For Users</h2>
//             </div>

//             <div className="faq-list">
//               {userFaqs.map((item, index) => (
//                 <div
//                   key={index}
//                   className={`faq-item ${openIndex === index ? "open" : ""}`}
//                 >
//                   <button
//                     className="faq-question"
//                     onClick={() => toggleQuestion(index, "user")}
//                   >
//                     <span>{item.q}</span>
//                     <FaChevronDown
//                       className={`faq-arrow ${
//                         openIndex === index ? "rotate" : ""
//                       }`}
//                     />
//                   </button>
//                   <div className="faq-answer">
//                     <p>{item.a}</p>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* SERVITOR SECTION */}
//           <div className="faq-block">
//             <div className="faq-block-header">
//               <FaTools className="faq-block-icon" />
//               <h2>For Servitors</h2>
//             </div>

//             <div className="faq-list">
//               {servitorFaqs.map((item, index) => (
//                 <div
//                   key={index}
//                   className={`faq-item ${openIndexServitor === index ? "open" : ""}`}
//                 >
//                   <button
//                     className="faq-question"
//                     onClick={() => toggleQuestion(index, "servitor")}
//                   >
//                     <span>{item.q}</span>
//                     <FaChevronDown
//                       className={`faq-arrow ${
//                         openIndexServitor === index ? "rotate" : ""
//                       }`}
//                     />
//                   </button>
//                   <div className="faq-answer">
//                     <p>{item.a}</p>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>

//       <Footer />
//     </div>
//     </>
//   );
// };

// export default FaqPage;









import React, { useState } from "react";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer/Footer";
import "./faqPageStyle.css";
import { FaChevronDown, FaUserAlt, FaTools } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import SEO from "../../Components/SEO/SEO";

const FaqPage = () => {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(null);
  const [openIndexServitor, setOpenIndexServitor] = useState(null);

  const toggleQuestion = (index, type = "user") => {
    if (type === "user") {
      setOpenIndex(openIndex === index ? null : index);
    } else {
      setOpenIndexServitor(openIndexServitor === index ? null : index);
    }
  };

  // ----- USER FAQ (from i18n) -----
  const userFaqs = [
    {
      q: t("faq.user.q1"),
      a: t("faq.user.a1"),
    },
    {
      q: t("faq.user.q2"),
      a: t("faq.user.a2"),
    },
    {
      q: t("faq.user.q3"),
      a: t("faq.user.a3"),
    },
    {
      q: t("faq.user.q4"),
      a: t("faq.user.a4"),
    },
    {
      q: t("faq.user.q5"),
      a: t("faq.user.a5"),
    },
    {
      q: t("faq.user.q6"),
      a: t("faq.user.a6"),
    },
    {
      q: t("faq.user.q7"),
      a: t("faq.user.a7"),
    },
    {
      q: t("faq.user.q8"),
      a: t("faq.user.a8"),
    },
  ];

  // ----- SERVITOR FAQ (from i18n) -----
  const servitorFaqs = [
    {
      q: t("faq.servitor.q1"),
      a: t("faq.servitor.a1"),
    },
    {
      q: t("faq.servitor.q2"),
      a: t("faq.servitor.a2"),
    },
    {
      q: t("faq.servitor.q3"),
      a: t("faq.servitor.a3"),
    },
    // {
    //   q: t("faq.servitor.q4"),
    //   a: t("faq.servitor.a4"),
    // },
    {
      q: t("faq.servitor.q5"),
      a: t("faq.servitor.a5"),
    },
    {
      q: t("faq.servitor.q6"),
      a: t("faq.servitor.a6"),
    },
    {
      q: t("faq.servitor.q7"),
      a: t("faq.servitor.a7"),
    },
  ];

  return (
    <>
      <div className="faq-page">
        <SEO
          title="HelpNao FAQ | Booking, Payments, Service Rules"
          description="Common questions about HelpNao services, booking, payments, refunds, and service providers."
          path="/helpfaqs"
          jsonLd={{
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": userFaqs.slice(0, 8).map((f) => ({
              "@type": "Question",
              "name": f.q,
              "acceptedAnswer": { "@type": "Answer", "text": f.a }
            }))
          }}
        />

        <Navbar />

        {/* Hero */}
        <section className="faq-hero">
          <div className="faq-container">
            <h1 className="faq-title">{t("faq.hero.title")}</h1>
            <p className="faq-subtitle">{t("faq.hero.subtitle")}</p>
          </div>
        </section>

        <section className="faq-section">
          <div className="faq-container">
            {/* USER SECTION */}
            <div className="faq-block">
              <div className="faq-block-header">
                <FaUserAlt className="faq-block-icon" />
                <h2>{t("faq.user.section_title")}</h2>
              </div>

              <div className="faq-list">
                {userFaqs.map((item, index) => (
                  <div
                    key={index}
                    className={`faq-item ${openIndex === index ? "open" : ""}`}
                  >
                    <button
                      className="faq-question"
                      onClick={() => toggleQuestion(index, "user")}
                    >
                      <span>{item.q}</span>
                      <FaChevronDown
                        className={`faq-arrow ${
                          openIndex === index ? "rotate" : ""
                        }`}
                      />
                    </button>
                    <div className="faq-answer">
                      <p>{item.a}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* SERVITOR SECTION */}
            <div className="faq-block">
              <div className="faq-block-header">
                <FaTools className="faq-block-icon" />
                <h2>{t("faq.servitor.section_title")}</h2>
              </div>

              <div className="faq-list">
                {servitorFaqs.map((item, index) => (
                  <div
                    key={index}
                    className={`faq-item ${
                      openIndexServitor === index ? "open" : ""
                    }`}
                  >
                    <button
                      className="faq-question"
                      onClick={() => toggleQuestion(index, "servitor")}
                    >
                      <span>{item.q}</span>
                      <FaChevronDown
                        className={`faq-arrow ${
                          openIndexServitor === index ? "rotate" : ""
                        }`}
                      />
                    </button>
                    <div className="faq-answer">
                      <p>{item.a}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
};

export default FaqPage;
